module.exports = __webpack_public_path__ + "static/YOLO-af67b0aebd7c6bbdd11d4543e4361c1e.png";